const setYAxisStackLabels = (yAxis, enabled) => {
    if (yAxis.stackLabels) {
        yAxis.stackLabels.enabled = enabled;
    }
};
export default {
    setYAxisStackLabels,
};
//# sourceMappingURL=blink-highchart-util.js.map